<template>
  <v-flex>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title>Valoraciones</v-toolbar-title>
        <v-divider class="mx-4" inset vertical />
        <v-spacer />
        <v-btn small depressed :color="colorAccent1" class="white--text" :loading="loading" @click="cargarResumen">
          <v-icon left>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
      </v-toolbar>
      <v-card-text>
        Consulta global de todas las valoraciones recibidas, organizada por tipo y proveedor.
      </v-card-text>
    </v-card>

    <div class="ma-2">
      <v-progress-linear
        v-if="loading"
        class="my-6"
        indeterminate
        :color="colorAccent1"
        rounded
        height="6"
      />

      <v-alert v-else-if="error" type="error" outlined>
        <div class="d-flex align-center">
          <span>{{ error }}</span>
          <v-spacer />
          <v-btn text small color="error" @click="cargarResumen">Reintentar</v-btn>
        </div>
      </v-alert>

      <template v-else-if="resumen">
        <valoraciones-seccion
          titulo="Rutas Meigas"
          icono="mdi-map"
          color="blue-grey darken-3"
          :resumen="resumen.rutas_meigas"
        />
        <valoraciones-seccion
          titulo="Alojamientos"
          icono="mdi-home-city"
          color="deep-orange darken-2"
          :resumen="resumen.alojamientos"
          agrupar-por-proveedor
        />
        <valoraciones-seccion
          titulo="Servicios"
          icono="mdi-briefcase"
          color="teal darken-2"
          :resumen="resumen.servicios"
          agrupar-por-proveedor
        />
      </template>
    </div>
  </v-flex>
</template>

<script>
import { mapState } from "vuex";
import ValoracionesSeccion from "@/components/valoraciones/ValoracionesSeccion.vue";
import { obtenerResumenValoraciones } from "@/services/valoraciones";

export default {
  name: "ValoracionesResumen",

  components: {
    ValoracionesSeccion,
  },

  data: () => ({
    loading: false,
    error: "",
    resumen: null,
  }),

  computed: {
    ...mapState(["dark", "colorBarraFormulario", "colorAccent1"]),
    ...mapState("auth", ["access_token"]),
  },

  created() {
    this.cargarResumen();
  },

  methods: {
    async cargarResumen() {
      if (this.loading) return;

      this.loading = true;
      this.error = "";

      try {
        this.resumen = await obtenerResumenValoraciones(this.access_token);
      } catch (error) {
        this.resumen = null;
        this.error = "No se pudo cargar el resumen de valoraciones.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
